import { useEffect, useState } from 'react';
import axios from 'axios';
import { Flame, X } from 'lucide-react';
import './DailySuperMeter.css';
import './DailySuperHit.css';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SEEN = 'ds_hit_seen';

// Site-wide celebration the moment the owner awards the Daily Super (shown once per hit, for 10 min after).
export const DailySuperHit = () => {
    const [hit, setHit] = useState(null);
    useEffect(() => {
        let alive = true;
        const load = () => axios.get(`${API}/jackpots/daily-super`).then(({ data }) => {
            const h = data?.last_hit;
            if (alive && h && localStorage.getItem(SEEN) !== h.id) setHit(h);
        }).catch(() => {});
        load();
        const iv = setInterval(load, 10000);
        return () => { alive = false; clearInterval(iv); };
    }, []);
    useEffect(() => {
        if (!hit) return undefined;
        localStorage.setItem(SEEN, hit.id);
        const t = setTimeout(() => setHit(null), 12000);
        return () => clearTimeout(t);
    }, [hit]);
    if (!hit) return null;
    const amount = Number(hit.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return (
        <div className="ds-hit" onClick={() => setHit(null)} role="alert" data-testid="daily-super-hit">
            <div className="ds-hit-card">
                <button type="button" className="ds-hit-x" aria-label="Close" data-testid="daily-super-hit-close"><X className="w-5 h-5" /></button>
                <div className="ds-flames ds-hit-flames" aria-hidden="true">{Array.from({ length: 11 }, (_, i) => <span key={i} className="ds-flame" />)}</div>
                <Flame className="mx-auto mb-1 h-10 w-10 text-[#FF7A00]" />
                <div className="ds-hit-eyebrow">The Daily Super Jackpot was just hit!</div>
                <div className="ds-hit-amount" data-testid="daily-super-hit-amount">${amount}</div>
                <div className="ds-hit-winner" data-testid="daily-super-hit-winner">Congratulations <b>{hit.winner || 'our lucky player'}</b>!</div>
                <div className="ds-hit-sub">Keep playing. The next Daily Super could be yours.</div>
            </div>
        </div>
    );
};

export default DailySuperHit;
